// "Order these groceries": choose which grocery app to order from. Every app then follows the
// same steps (address → products → the app's own preview → confirm).
import { Link } from '../router';
import { Back, Next } from '../icons';
import { useProviders } from '../commerce';
import { groceryIDs } from '../grocery-selection';
import { useT } from '../i18n';

export function GroceryApps() {
  const t = useT();
  const [providers] = useProviders();
  const apps = providers.filter((p) => p.kind === 'grocery');
  const n = groceryIDs().length;
  return (
    <div class="page">
      <div class="backbar"><Link href="/grocery" class="icon-btn" aria-label={t('common.back')}><Back /></Link></div>
      <div class="pad" style="display:flex;flex-direction:column;gap:4px">
        <h1 class="h1" style="font-size:28px">{t('apps.title')}</h1>
        <span class="muted">{t('apps.sub', { n })}</span>
      </div>
      {n === 0 && <div class="hint-box" style="margin:16px">{t('order.emptyList')} <Link href="/grocery">{t('grocery.title')}</Link></div>}
      {n > 0 && apps.length === 0 && <div class="hint-box" style="margin:16px">{t('apps.none')}</div>}
      {n > 0 && apps.length > 0 && (
        <div class="rows" style="margin:16px">
          {apps.map((a) => a.coming_soon ? (
            <div class="row is-soon" style="min-height:72px" aria-disabled="true">
              <span class="grow">
                <span style="font-weight:800;font-size:17px">{a.name}</span>
                <span class="sub">{t('soon.body', { app: a.name })}</span>
              </span>
              <span class="soon-badge">{t('soon.badge')}</span>
            </div>
          ) : (
            <Link href={`/grocery/order/${a.id}`} class="row" style="min-height:72px">
              <span class="grow">
                <span style="font-weight:800;font-size:17px">{a.name}</span>
                <span class="sub">{a.connected ? t('settings.connected') : t('apps.signIn')}</span>
              </span>
              <Next size={20} />
            </Link>
          ))}
        </div>
      )}
      <p class="pad small muted" style="line-height:1.5">{t('apps.note')}</p>
    </div>
  );
}
